import React, { PropsWithChildren, forwardRef } from "react";
import Footer from "@/components/Footer";
import LayoutUI, { LayoutContent } from "@/componentsUI/Layout";
import {
  Routes,
  Route,
  Navigate,
  useParams,
  useLocation,
} from "react-router-dom";
import "./index.less";
import { routes } from "@/routes/routes";
import KeepAlive from "react-activation";
import { getRoute } from "@/routes";
import Private from "@/routes/Private";
import { getCurrentSiteName } from "@/utils/countryConfigUtils";
export interface Props {
  className?: string;
}

function RedirectToHome() {
  const location = useLocation();
  const search = location.search;

  return <Navigate to={`/home${search}`} replace={true} />;
}

const LayoutMain = (props: PropsWithChildren<Props>, ref) => {
  const { className } = props;
  const allRoutes = getRoute(routes);
  const siteName = getCurrentSiteName();
  return (
    <LayoutUI ref={ref} className={className}>
      <LayoutContent className={`layout-main-content`}>
        {/* <CustomerService2 /> */}

        <Routes>
          {allRoutes.map(
            ({ path, auth, component: CompomentTSX, cache }, index) => {
              return (
                <Route
                  key={index}
                  path={`${path}`}
                  element={
                    auth ? (
                      cache ? (
                        <KeepAlive id={path}>
                          <Private>
                            <CompomentTSX />
                          </Private>
                        </KeepAlive>
                      ) : (
                        <Private>
                          <CompomentTSX />
                        </Private>
                      )
                    ) : cache ? (
                      <KeepAlive id={path}>
                        <CompomentTSX />
                      </KeepAlive>
                    ) : (
                      <CompomentTSX />
                    )
                  }
                />
              );
            }
          )}
          <Route path={"/"} element={<RedirectToHome />} />
          <Route path="*" element={<Navigate to="/home" replace={true} />} />
        </Routes>
      </LayoutContent>
      <Footer>
        {`Copyright © ${siteName}`}
      </Footer>
    </LayoutUI>
  );
};

export default React.memo(forwardRef(LayoutMain));
